/* eslint-disable */
/**
 * Auto generated version file, do not modify it!
 */
const version = '1.32.12-beta';
export { version };
//# sourceMappingURL=version.js.map